import { render } from "./complete-call-for-competition.svg?vue&type=template&id=25b0fcdd"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__